<ng-container *ngIf="loader">
  <ion-grid class="side-menu-wrapper text-center">
    <ion-spinner class="ion-spinner"></ion-spinner>
  </ion-grid>
</ng-container>

<ng-container *ngIf="!loader">
  <ion-grid>
    <ion-row>
      <ion-col>
        <ion-grid class="max-w-1336">
          <ion-row class="py-16">
            <ion-col size="6">
              <ion-grid>
                <ion-row>
                  <ion-col size="12">
                    Id : {{ data.ID }}
                  </ion-col>
                  <ion-col size="12">
                    courseID : {{ data.courseID }}
                  </ion-col>
                  <ion-col size="12">
                    email_template : {{ data.email_template }}
                  </ion-col>
                  <ion-col size="12">
                    subject : {{ data.subject }}
                  </ion-col>
                </ion-row>
              </ion-grid>
            </ion-col>
            <ion-col size="6">
              <ion-button class="Small-button-Active_primary_with_icon" (click)="updateEmailTemplate()">
                Update
              </ion-button>
            </ion-col>
          </ion-row>
          <ion-row>
            <ion-col size="12">
              <editor apiKey="o1vl7y2crz2c783nntt3nst6jtqs3n5yksw8nfng5q5i0f49" [init]="init" [(ngModel)]="data.body">
              </editor>
            </ion-col>
          </ion-row>
        </ion-grid>
      </ion-col>
    </ion-row>
  </ion-grid>


</ng-container>